export default __webpack_public_path__ + "static/media/r3.f590cabc.jpg";